module.exports = __webpack_public_path__ + "img/guanwang_icon_bofang.d954c5f5.svg";